<header class="flex header p-2">
  <h2>{{ 'EmployeeAccount_Modal_Title' | translateWF: 'Add employee' }}</h2>
  <p-button icon="pi pi-times" variant="text" (click)="onClose()" />
</header>

<section class="content">
  <div class="flex flex-col gap-4">
    <p-panel [header]="'EmployeeAccount_Modal_New' | translateWF: 'New employee from a Nexus user'">
      <div class="flex flex-col gap-3">
        <small class="text-surface-500">
          {{
            'EmployeeAccount_Modal_New_Hint'
              | translateWF: 'Creates a Standard employee named after the user and enables it with the default accounts. Costing employees are not affected.'
          }}
        </small>
        <div class="flex gap-2 items-center">
          <p-autocomplete
            class="flex-1"
            [formControl]="userControl"
            [suggestions]="userSuggestions()"
            (completeMethod)="searchUsers($event)"
            optionLabel="displayName"
            [dropdown]="true"
            [forceSelection]="true"
            [fluid]="true"
            [placeholder]="'EmployeeAccount_Modal_User' | translateWF: 'Search a Nexus user'"
          >
            <ng-template #item let-user>
              <div class="flex flex-col">
                <span>{{ user.displayName }}</span>
                <small class="text-surface-500">{{ user.username }}</small>
              </div>
            </ng-template>
          </p-autocomplete>
          <p-button
            [label]="'EmployeeAccount_Modal_CreateEnable' | translateWF: 'Create and enable'"
            icon="pi pi-plus"
            [loading]="creating()"
            [disabled]="!userControl.value"
            (click)="createAndEnable()"
          />
        </div>
      </div>
    </p-panel>

    <small class="text-surface-500">
      {{ 'EmployeeAccount_Modal_Hint' | translateWF: 'Or enable an existing Standard employee.' }}
    </small>

    <p-iconfield>
      <p-inputicon styleClass="pi pi-search" />
      <input pInputText class="w-full" [formControl]="searchControl" [placeholder]="'EmployeeAccount_Modal_Search' | translateWF: 'Search by code or name'" />
    </p-iconfield>

    <p-table [value]="candidates()" dataKey="employeeReference" [rowHover]="true" [loading]="isSearching()" size="small">
      <ng-template pTemplate="header">
        <tr>
          <th style="width: 9rem">{{ 'EmployeeAccount_Col_Code' | translateWF: 'Code' }}</th>
          <th>{{ 'EmployeeAccount_Col_Name' | translateWF: 'Name' }}</th>
          <th>{{ 'EmployeeAccount_Col_User' | translateWF: 'Nexus user' }}</th>
          <th class="text-right" style="width: 10rem"></th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-rowData>
        @let row = getRow(rowData);
        <tr>
          <td class="font-mono">{{ row.employeeCode }}</td>
          <td>{{ row.name }}</td>
          <td>{{ row.username ?? '—' }}</td>
          <td class="text-right">
            @if (row.isEnabled) {
              <p-button
                [label]="'EmployeeAccount_Modal_Open' | translateWF: 'Enabled · open'"
                icon="pi pi-check"
                severity="success"
                variant="text"
                size="small"
                (click)="open(row)"
              />
            } @else {
              <p-button
                [label]="'EmployeeAccount_Modal_Enable' | translateWF: 'Enable'"
                icon="pi pi-plus"
                size="small"
                [loading]="enabling() === row.employeeReference"
                [disabled]="enabling() !== null"
                (click)="enable(row)"
              />
            }
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="4" class="text-center">{{ 'EmployeeAccount_Modal_Empty' | translateWF: 'No employees match.' }}</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</section>

<footer>
  <p-button [label]="'Cancel' | translateWF: 'Cancel'" variant="outlined" (click)="onClose()" />
</footer>
